import styled from 'styled-components'
import { breakpoints } from '../../constants'

export const StyledRegister = styled.div`
	padding: 3rem 0;
`

export const StyledStepFrom = styled.div`
	padding: 2rem 1rem 1rem;
`
export const StyleSocialLogin = styled.div`
	.social-login-container {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		margin-bottom: 10px;

		button {
			width: 300px;
			margin-top: 10px;
		}

		@media screen and (max-width: ${breakpoints.MOBILE}px) {
			display: flex;
			width: 100%;
			button {
				height: 40px;
			}
		}
	}
	.custom-google-button {
		height: 56px;
		padding-left: 1.8rem !important;
		padding-right: 1.8rem !important;
	}

	.custom-facebook-button {
		font-size: 18px;
		height: 56px;
		border-radius: 5px;
		padding: 0 3.4rem;
		background-color: #1977f3;
		display: inline-flex;
		align-items: center;
		color: white;
		border: 1px solid transparent;
		font-weight: 500;
		font-family: Roboto, sans-serif;
		cursor: pointer;
	}

	.custom-facebook-button img {
		margin: 0 16px 0px 3px;
	}
`
export const StyledPage = styled.div`
	flex-direction: column;
	align-items: center;
	justify-content: center;
	margin-bottom: 4.6rem;

	p {
		text-align: center;
	}

	.custom-word-break {
		display: none;
	}

	@media (max-width: 320px) {
		.custom-word-break {
			display: block;
		}
	}
`
